import { useEffect, useMemo } from "react"
import { Card, Icon, Input, Menu, Table } from 'semantic-ui-react'
import { useState } from "react"
import { Link } from "react-router-dom"
import { useUserStore, UserType } from "../store"
import debounce from 'lodash.debounce'
import BasePage from "../../../components/BasePage"
import Loading from "../../../components/loading"

const PageUsers=() => {
  const store = useUserStore()
  const [users, setUsers] = useState<UserType[]>()
  const [page, setPage] = useState<number>(1)
  const [numPages, setNumPages] = useState<number>(1)
  const [searchString, setSearchString] = useState<string>()
  useEffect(() => {
    store.list(page, searchString).then(({results, num_pages}) => {
      setUsers(results)
      setNumPages(num_pages)
    })
  }, [page, searchString])
  const handleSearch = (e: any, data: any) => {
    setSearchString(data.value)
  }
  const debouncedHandleSearch = useMemo(
    () => debounce(handleSearch, 300)
  , [])
  useEffect(() => {
    return () => { debouncedHandleSearch.cancel() }
  }, []);
  return (
    <BasePage>
      <Input fluid placeholder='Pesquisar' onChange={debouncedHandleSearch}/>
      {store.checkLoading('list') && <Loading />}
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.Cell>Nome de usuário</Table.Cell>
            <Table.Cell>Email</Table.Cell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
        {users?.map(u =>
          <Table.Row key={u.id}>
            <Table.Cell><Link to={`/auth/users/${u.id}`}>{u.username}</Link></Table.Cell>
            <Table.Cell>{u.email}</Table.Cell>
          </Table.Row>
        )}
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            <Table.HeaderCell colSpan='3'>
              <Menu floated='right' pagination>
                <Menu.Item as='a' icon onClick={()=>page > 1 && setPage(page-1)}>
                  <Icon name='chevron left' />
                </Menu.Item>
                {[...Array(numPages)].map((_, i) =>
                  <Menu.Item as='a'
                    onClick={()=>setPage(i+1)}
                    active={page===i+1}
                  >
                    {i+1}
                  </Menu.Item>
                )}
                <Menu.Item as='a' icon
                    onClick={()=>page < numPages && setPage(page+1)}>
                  <Icon name='chevron right' />
                </Menu.Item>
              </Menu>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </BasePage>
  )
}

export default PageUsers